import { Outlet } from 'react-router-dom';
import { BoxFullWH } from '../layout.styles';

const ContentWrapper = () => {
    return (
        <BoxFullWH px={3} pb={3} overflow={'hidden'}>
            <Outlet />
        </BoxFullWH>
    );
};

export default ContentWrapper;
